(() => {
  const contents = document.querySelector('.nx-policy-contents');
  const policy = document.querySelector('.nx-policy-body');
  if (contents && policy) {
    const nav = contents.querySelector('nav');
    const summary = contents.querySelector('summary');
    const narrow = matchMedia('(max-width: 760px)');
    const fragment = document.createDocumentFragment();
    policy.querySelectorAll('h2,h3').forEach((heading, index) => {
      if (!heading.textContent.trim()) return;
      if (!heading.id) {
        let id = `nana-policy-section-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      heading.tabIndex = -1;
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', event => {
        // Close before the native anchor jump calculates its final position.
        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && narrow.matches) contents.open = false;
      });
      fragment.append(link);
    });
    nav.replaceChildren(fragment);
    contents.hidden = !nav.children.length;
    const fit = () => { contents.open = !narrow.matches; };
    fit();
    narrow.addEventListener('change', fit);
    contents.addEventListener('keydown', event => {
      if (event.key === 'Escape' && narrow.matches && contents.open) {
        contents.open = false;
        summary.focus();
      }
    });
    const markSection = () => nav.querySelectorAll('a').forEach(link => {
      if (link.hash === location.hash) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    markSection();
    addEventListener('hashchange', markSection);
  }
  const reduced = window.nanaMotion || matchMedia('(prefers-reduced-motion: reduce)');
  const art = document.querySelector('[data-contact-art]');
  if (art && !reduced.matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      if (!reduced.matches) {
        art.classList.add('is-entering');
        const mark = art.querySelector('[data-motion-src]');
        if (mark) mark.src = mark.dataset.motionSrc;
      }
      observer.disconnect();
    }, {threshold: .12});
    observer.observe(art);
  }
  if (art) {
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    let frame = 0;
    let box = null;
    const reset = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      box = null;
      art.style.removeProperty('--nx-drift-x');
      art.style.removeProperty('--nx-drift-y');
    };
    art.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' && fine.matches && !reduced.matches) box = art.getBoundingClientRect();
    });
    art.addEventListener('pointermove', event => {
      if (!box || reduced.matches || !fine.matches || document.hidden || event.pointerType !== 'mouse') return;
      const x = Math.max(-6, Math.min(6, ((event.clientX - box.left) / box.width - .5) * 12));
      const y = Math.max(-6, Math.min(6, ((event.clientY - box.top) / box.height - .5) * 12));
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        art.style.setProperty('--nx-drift-x', `${x.toFixed(2)}px`);
        art.style.setProperty('--nx-drift-y', `${y.toFixed(2)}px`);
        frame = 0;
      });
    });
    art.addEventListener('pointerleave', reset);
    art.addEventListener('pointercancel', reset);
    art.addEventListener('focusin', reset);
    addEventListener('scroll', reset, {passive: true});
    addEventListener('resize', reset, {passive: true});
    addEventListener('pagehide', reset);
    document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
    fine.addEventListener('change', reset);
    reduced.addEventListener('change', () => {
      if (reduced.matches) { reset(); art.classList.remove('is-entering'); }
    });
  }
})();
